import { render, staticRenderFns } from "./ProductNgEdit.vue?vue&type=template&id=ae2581e8&"
import script from "./ProductNgEdit.vue?vue&type=script&lang=js&"
export * from "./ProductNgEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports